import axios from 'axios';
import { ENV_BACKOFFICE_API_URL } from 'common/constants/env.constants.ts';
import {
  IBackofficeDictionary,
  IBackofficeUniqueDataResponse,
} from 'domains/backoffice/interfaces/backoffice.interfaces.ts';

const backofficeApiClient = axios.create({
  baseURL: ENV_BACKOFFICE_API_URL,
});

export const getBackofficeDictionaryService = async (token: string): Promise<IBackofficeDictionary> => {
  const { data } = await backofficeApiClient.post<IBackofficeUniqueDataResponse>(
    '/transactions/get-unique',
    {
      dictionary_names: ['payment_method_info', 'merchant_info'],
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return {
    merchants:
      data.merchant_info?.map((merchant) => ({
        guid: merchant.merchant_guid,
        name: merchant.merchant_name,
      })) ?? [],
    paymentMethods:
      data.payment_method_info?.map((paymentMethod) => ({
        guid: paymentMethod.payment_method_guid,
        name: paymentMethod.payment_method_name,
      })) ?? [],
  };
};
